import { compose } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../../actions/SeminarManagementOrganizer';
import SeminarManagementSelector from '../../selectors/SeminarManagementOrganizer';
import withAuth from '../../common/WithAuth';
import ListSeminar from '../../pages/SeminarManagementOrganizer/ListSeminar';
import { GetDetailCompanyOrganizerRequested, ClearGetDetailCompanyOrganizer } from '../../actions/CompanyManagementOrganizer';
import DetailCompanyOrganizerSelector from '../../selectors/DetailCompanyOrganizer';

const mapStateToProps = (state) => {
    const listSeminar = SeminarManagementSelector.createSeminarManagementResultsSelector()(state);
    const detailCompany = DetailCompanyOrganizerSelector.createDetailCompanyOrganizerResultsSelector()(state);
    const isLoading = state.seminarManagementOrganizer.get.isFetching
    || state.seminarManagementOrganizer.detailSeminar.isFetching
    || state.companyManagementOrganizer.detailCompanyOrganizer.isFetching
    || state.registration.registrationViewer.isFetching;

    return {
        listSeminar,
        seminars: state.seminarManagementOrganizer.get.data,
        detailSeminar: state.seminarManagementOrganizer.detailSeminar.data,
        updateSeminarSuccess: state.seminarManagementOrganizer.updateSeminar.updateSeminarSuccess,
        errors: state.seminarManagementOrganizer.updateSeminar.errors,
        detailCompany,
        eventInfo: state.registration.registrationViewer.data,
        isFetchingUpdate: state.seminarManagementOrganizer.updateSeminar.isFetching,
        percent: state.seminarManagementOrganizer.updateSeminar.percent,
        isLoading,
        token: state.auth.credential.data.token,
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchListSeminar: (params) => {
        dispatch(Actions.GetListSeminarRequested(params));
    },
    updateSeminar: (params) => {
        dispatch(Actions.UpdateSeminarRequested(params));
    },
    getDetailSeminar: (params) => {
        dispatch(Actions.GetDetailSeminarRequested(params));
    },
    getDetailCompany: () => {
        dispatch(GetDetailCompanyOrganizerRequested());
    },
    clearDetailComopany: () => {
        dispatch(ClearGetDetailCompanyOrganizer());
    },
    clearDetailSeminar: () => {
        dispatch(Actions.ClearDetailSeminar());
    },
    clearListSeminar: () => {
        dispatch(Actions.ClearListSeminar());
    },
    clearUpdateSeminar: () => {
        dispatch(Actions.ClearUpdateSeminar());
    },
});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListSeminar);
